import {TFunction} from "react-i18next";
import {ColumnsType} from "antd/lib/table/interface";
import {Link} from "react-router-dom";
import React from "react";
import {Space} from "antd";
import {PaymentStatus} from "./ui/status/status";
import {Statement, StatementPaymentStatus} from "../../../../models/accounting/client-statements";
import {Price} from "../../../common/price/price";
import Date from "../../../date/date";
import {ExpandableConfig} from "antd/es/table/interface";

export const columnsFactory = (t: TFunction<"translation">, currencyCode: string): ColumnsType<Statement & ExpandableConfig<Statement>> => {
    return [
        {
            title: t("INVOICE.NUMBER"),
            dataIndex: "number",
            key: "number",
            render: (number: string, item) => {
                switch (item.type) {
                    case "merged_invoice":
                        return <Link to={"/merged-invoices/" + item.id}>
                            <span style={{whiteSpace: "nowrap"}}>{number}</span>
                        </Link>
                    case "credit_invoice":
                        return <Link to={"/credit-invoices/" + item.id}>
                            <span style={{whiteSpace: "nowrap"}}>{number}</span>
                        </Link>
                    default:
                        return "-";
                }
            }
        },
        {
            title: t("STATUS"),
            dataIndex: "paymentStatus",
            key: "paymentStatus",
            render: (status: StatementPaymentStatus) => <PaymentStatus status={status} />
        },
        {
            title: t("DUE_DATE"),
            dataIndex: "dueDate",
            key: "dueDate",
            render: (date: string, item) => <Space direction={"horizontal"}>
                {item.type === "merged_invoice" ? (<>
                    <div style={item.paymentStatus === 'overdue' ? ({color: "red"}) : ({})}>
                        <Date dateString={date} />
                    </div>
                </>) : <>-</>}
            </Space>,
        },
        {
            title: <b>{t("ENDING_BALANCE")}</b>,
            dataIndex: "endingBalance",
            key: "endingBalance",
            render: (v, item) => <div style={item.overdue && item.type === "merged_invoice" ? ({color: "red"}) : ({})}>
                <Price value={{value: v, currencyCode: currencyCode as any}}/>
            </div>
        },
        {
            title: t("SUBTOTAL"),
            dataIndex: "subtotal",
            key: "subtotal",
            render: v => <Price value={{value: v, currencyCode: currencyCode as any}} />
        },
        {
            title: t("TAX.TITLE"),
            dataIndex: "tax",
            key: "tax",
            render: v => <Price value={{value: v, currencyCode: currencyCode as any}} />
        },
        {
            title: t("GRAND_TOTAL_PRICE"),
            dataIndex: "grandtotal",
            key: "grandtotal",
            render: v => <Price value={{value: v, currencyCode: currencyCode as any}} />
        },
        {
            title: t("DATE"),
            dataIndex: "date",
            key: "date",
            render: (date: string) => <Date dateString={date} />,
        }
    ]
}